import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faFileExcel, faFileExport } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Space, Tooltip } from 'antd';
import React, { useState } from 'react';
import ExportModal from '../../components/modals/ExportModal';
import { Company } from '../../models/company-interface';
import { CompanyUserProfile } from '../../models/company-user-profile-interface';
import { CSSearchResults } from '../../models/cs-search-results-interface';
import { ExcelWorkbook, exportToExcel, TableAndExcelColumn } from '../../utilites/exportToExcel';
import { HasRight, Rights } from '../../utilites/auth';

interface SearchExportProps {
  getColumns(): TableAndExcelColumn<CompanyUserProfile>[] | TableAndExcelColumn<Company>[];
  getData(): CSSearchResults | undefined;
  getActiveKey(): string;
  fileName: string;
  disabled: boolean;
  excludeDemo: boolean;
  allowDeletion: boolean;
  deletionEnabled: boolean;
  setShowDeletionModal: (show: boolean) => void;
}

export default function SearchExport({
  getColumns,
  getData,
  getActiveKey,
  excludeDemo,
  fileName,
  disabled,
  allowDeletion,
  deletionEnabled,
  setShowDeletionModal
}: SearchExportProps) {
  const [showExportModal, setShowExportModal] = useState(false);

  const exportData = ():CompanyUserProfile[] | Company[] => {
    const data = getData();
    const activeKey = getActiveKey();

    const filteredUsers = data?.users?.filter(x => (excludeDemo ? !x.isDemoCompany : true))
    const filteredCompanies = data?.companies?.filter(x => (excludeDemo ? !x.isDemoCompany : true))

    const hasUserData = !!filteredUsers?.length;
    const hasCompanyData = !!filteredCompanies?.length;
    const dataToExport =
      hasUserData && !hasCompanyData
          ? filteredUsers
          : hasCompanyData && !hasUserData
          ? filteredCompanies
          : activeKey === 'users'
          ? filteredUsers
          : filteredCompanies;

    return dataToExport ?? []
  }

  const handleExport = () => {
    const columns = getColumns();
    const data = getData();
    const activeKey = getActiveKey();

    const filteredUsers = data?.users?.filter(x => (excludeDemo ? !x.isDemoCompany : true))
    const filteredCompanies = data?.companies?.filter(x => (excludeDemo ? !x.isDemoCompany : true))

    const hasUserData = !!filteredUsers?.length;
    const hasCompanyData = !!filteredCompanies?.length;
    const dataToExport =
      hasUserData && !hasCompanyData
          ? filteredUsers
          : hasCompanyData && !hasUserData
          ? filteredCompanies
          : activeKey === 'users'
          ? filteredUsers
          : filteredCompanies;
    const tabName =
          hasUserData && !hasCompanyData
              ? 'Users'
              : hasCompanyData && !hasUserData
              ? 'Companies'
              : activeKey === 'users'
              ? 'Users'
              : 'Companies';

    if (!!columns && !!dataToExport) {
      const workbook: ExcelWorkbook = {
        fileName: fileName,
        worksheets: [
          {
            name: tabName,
            columns: columns,
            data: dataToExport,
          },
        ],
      };
      exportToExcel({
        excelWorkbook: workbook,
      });
    }
  };

  return (
    <>
      <Space>
        {(HasRight([Rights.CSSuperUser]) && allowDeletion) && (
          <Tooltip overlay='Request Company Deletion'>
            <Button
              type='primary'
              onClick={() => setShowDeletionModal(true)}
              disabled={!deletionEnabled}
              title="Request Company Deletion"
            >Request Company Deletion</Button>
          </Tooltip>
        )}
        <Tooltip overlay='Export to Excel'>
          <Button
            type='primary'
            onClick={() => setShowExportModal(true)}
            disabled={disabled || (exportData() == null || exportData().length === 0)}
            title="Export XLS"
          ><Space><FontAwesomeIcon icon={faFileExport as IconProp} /> Export XLS</Space></Button>
        </Tooltip>
      </Space>
      <ExportModal
        show={showExportModal}
        onClose={() => setShowExportModal(false)}
        onDownloadFile={() => handleExport()}
      />
    </>
  );
}
